import { Controller } from '@hotwired/stimulus';

// Grid de frota: expande os equipamentos de um veículo, filtra pelo servidor
// (estado e comunicação saem da última posição, não de coluna) e recarrega o
// corpo da tabela em intervalo fixo.
export default class extends Controller {
  static targets = ['frame', 'search', 'state', 'offline', 'equipmentType', 'count', 'equipmentRow', 'caret', 'lastUpdate']
  static values = { url: String, interval: { type: Number, default: 60000 } }

  connect() {
    this.lastLoadedAt = new Date();
    this.clock = setInterval(() => this.paintElapsed(), 10000);
    this.timer = setInterval(() => this.reload(), this.intervalValue);
  }

  disconnect() {
    clearInterval(this.clock);
    clearInterval(this.timer);
    clearTimeout(this.debounce);
  }

  toggle(event) {
    const parent = event.currentTarget.dataset.parent;
    const rows = this.equipmentRowTargets.filter((row) => row.dataset.parent === parent);
    const expanded = rows.some((row) => row.classList.contains('hidden'));

    rows.forEach((row) => row.classList.toggle('hidden', !expanded));

    const caret = this.caretTargets.find((element) => element.dataset.parent === parent);
    if (caret) caret.textContent = expanded ? '▾' : '▸';
  }

  // Digitar recarrega, mas não a cada tecla.
  filter() {
    clearTimeout(this.debounce);
    this.debounce = setTimeout(() => this.reload(), 300);
  }

  async reload() {
    const response = await fetch(`${this.urlValue}?${this.params()}`, {
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
    }).catch(() => null);

    if (!response || !response.ok) return;

    this.frameTarget.innerHTML = await response.text();
    this.lastLoadedAt = new Date();
    this.paintElapsed();
    this.paintCount();
  }

  params() {
    const params = new URLSearchParams();

    if (this.hasSearchTarget && this.searchTarget.value.trim() !== '') {
      params.set('q', this.searchTarget.value.trim());
    }

    this.stateTargets.filter((input) => input.checked).forEach((input) => params.append('state[]', input.value));
    if (this.hasOfflineTarget && this.offlineTarget.checked) params.set('offline', '1');
    this.equipmentTypeTargets.filter((input) => input.checked).forEach((input) => params.append('equipment_type[]', input.value));

    return params.toString();
  }

  paintCount() {
    if (!this.hasCountTarget) return;

    // Linha de equipamento não conta: o contador é de veículos.
    this.countTarget.textContent = this.frameTarget.querySelectorAll('tbody > tr:not([data-parent])').length;
  }

  paintElapsed() {
    if (!this.hasLastUpdateTarget) return;

    const seconds = Math.floor((new Date() - this.lastLoadedAt) / 1000);

    if (seconds < 10) this.lastUpdateTarget.textContent = 'agora';
    else if (seconds < 60) this.lastUpdateTarget.textContent = `${seconds}s`;
    else this.lastUpdateTarget.textContent = `${Math.floor(seconds / 60)}min`;
  }
}
